module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-16.b3e0d189.png";